import { useCallback } from "react";
import { useCopyToClipboard } from "react-use";

import { toastify } from "@vendors";
import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

export default function ActionMenuClipboardCopyItem(props) {
  const {
    value,
    valueFn,
    successMessage = "Copied to Clipboard!",
  } = props;

  const [clipboard, copyToClipboard] = useCopyToClipboard();

  const handleClick = useCallback((_event) => {
    if (!value && !valueFn) return;

    if (value) {
      copyToClipboard(value);
    } else {
      copyToClipboard(valueFn());
    }

    if (!clipboard.error) {
      toastify.info(successMessage);
    }
  }, [
    copyToClipboard,
    successMessage,
    value,
    valueFn,
    clipboard.error,
  ]);

  /**************************************************************************************************/

  return (
    <ActionMenuBaseItem
      onClick={handleClick}
      {...props}
    />
  );
}
